import React, {Children, useCallback, useRef, useState} from 'react';
import PropTypes from 'prop-types';

import {Box} from '@mui/material';

import {red600} from "../assets/jss/main";

const GAP = 16;

function MobileCarousel({ children, peek = 56, slideMinHeight }) {
    const scrollRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);

    const count = Children.count(children);

    const handleScroll = useCallback(() => {
        const el = scrollRef.current;

        if (!el) {
            return;
        }

        const step = el.offsetWidth - peek + GAP;
        const index = Math.round(el.scrollLeft / step);

        setActiveIndex(Math.max(0, Math.min(index, count - 1)));
    }, [count, peek]);

    return (
        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            <Box
                ref={scrollRef}
                onScroll={handleScroll}
                sx={{
                    display: 'flex',
                    gap: `${GAP}px`,
                    overflowX: 'auto',
                    scrollSnapType: 'x mandatory',
                    scrollPaddingLeft: '16px',
                    paddingTop: '4px',
                    paddingBottom: '14px',
                    scrollbarWidth: 'none',
                    WebkitOverflowScrolling: 'touch',
                    '&::-webkit-scrollbar': { display: 'none' },
                }}
            >
                {Children.map(children, (child, i) => (
                    <Box
                        key={i}
                        sx={{
                            flex: `0 0 calc(100% - ${peek}px)`,
                            scrollSnapAlign: 'start',
                            minWidth: 0,
                            alignSelf: 'stretch',
                            display: 'flex',
                            flexDirection: 'column',
                            ...(slideMinHeight ? { minHeight: slideMinHeight } : {}),
                        }}
                    >
                        {child}
                    </Box>
                ))}
            </Box>

            {count > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: '6px', mt: '4px' }}>
                    {Array.from({ length: count }).map((_, i) => (
                        <Box
                            key={i}
                            sx={{
                                height: '6px',
                                width: i === activeIndex ? '18px' : '6px',
                                borderRadius: i === activeIndex ? '3px' : '50%',
                                backgroundColor: i === activeIndex ? red600 : '#D1D5DB',
                                transition: 'all 0.2s',
                                flexShrink: 0,
                            }}
                        />
                    ))}
                </Box>
            )}
        </Box>
    );
}

MobileCarousel.propTypes = {
    children: PropTypes.node,
    peek: PropTypes.number,
    slideMinHeight: PropTypes.number,
};

export default MobileCarousel;
